import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Transition } from "../../pages/app/utils/animation";
import { Warning } from "@mui/icons-material";
import { useModals } from "../../store/dialogs/hooks.js";

export const SyncSelectedDialog = ({
  onSyncSelectedClose,
  onSyncSelectedContinue,
}) => {
  const { showSyncSelectedDialog } = useModals();
  return (
    <Dialog
      aria-hidden={!showSyncSelectedDialog}
      closeAfterTransition={false}
      open={showSyncSelectedDialog}
      onClose={onSyncSelectedClose}
      aria-labelledby="sync-selected-title"
      aria-describedby="sync-selected-description"
      maxWidth="xs"
      slots={{
        transition: Transition,
      }}
      keepMounted
    >
      <DialogTitle
        display="flex"
        alignItems="center"
        gap={0.5}
        id="sync-selected-title"
      >
        <Warning color="warning" fontSize="medium" />
        Warning
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="sync-selected-description">
          You have indicated in the clip details that this clip is already
          aligned to a common clock. If this is true, running the SYNC filter
          may not be necessary. Are you sure you wish to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onSyncSelectedClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSyncSelectedContinue}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
